import EditorActions from './EditorActions';


/**
 * @type { import('didi').ModuleDeclaration }
 */
export default {
  __init__: [ 'editorActions' ],
  editorActions: [ 'type', EditorActions ]
};
